// src/components/KpiCard.jsx
//
// KPI-CARD-ROW-STANDARDIZE — §8 KPI Card Row spec (v0.9 style guide).
//
// KpiCard  — single card: white bg, 1px border, radius 11, flex-column.
//   Props:
//     label      {string}        — uppercase eyebrow label
//     value      {string|number} — main display value
//     sub        {string}        — optional sub-line beneath value
//     valueColor {string}        — CSS color (defaults to T.dark)
//     testid     {string}        — data-testid on the root element
//
// KpiCardRow — flex-row wrapper so cards share equal height (alignItems: stretch).
//   Props:
//     children  {ReactNode}
//     testid    {string}    — data-testid on the wrapper (optional)
//     style     {object}    — additional inline styles (optional)

import React from "react";
import { T } from "../app/tokens.js";

export function KpiCard({ label, value, sub, valueColor, testid }) {
  return (
    <div
      data-testid={testid}
      style={{
        background:    T.card,
        border:        `1px solid ${T.border}`,
        borderRadius:  11,
        padding:       "12px 15px",
        display:       "flex",
        flexDirection: "column",
        justifyContent:"center",
        flex:          1,
        minWidth:      0,
      }}
    >
      <div
        style={{
          fontSize:      T.fsXxxs5,
          fontWeight:    T.fwBold,
          textTransform: "uppercase",
          letterSpacing: 0.3,
          color:         T.mid,
        }}
      >
        {label}
      </div>
      <div
        style={{
          fontSize:   T.fsLgX5,
          fontWeight: T.fwSemibold,
          marginTop:  3,
          color:      valueColor ?? T.dark,
        }}
      >
        {value}
      </div>
      {sub != null && sub !== undefined && (
        <div
          style={{
            fontSize:  T.fsXxs,
            color:     T.light,
            marginTop: 2,
          }}
        >
          {sub}
        </div>
      )}
    </div>
  );
}

export function KpiCardRow({ children, testid, style }) {
  return (
    <div
      data-testid={testid}
      style={{
        display:    "flex",
        gap:        12,
        alignItems: "stretch",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
